import React, { useState } from 'react';
import { useWindowSize } from 'react-use';
import { isEmpty } from 'lodash';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import c from '../../config';
import { isExternalURL, is_Preview, parseSanitizedHTML } from '../../utils/Helper';

import HeaderBar from '../HeaderBar';
// import MobileMenu from '../MobileMenu';
import MobilePopMenu from '../MobilePopMenu';
import MenuButtons from '../MenuButtons';
import LangSwitcher from '../LangSwitcher';

const MainMenu = (props) => {
  const {
    logo = {},
    banner = {},
    curLang,
    menu,
    headerStyle,
    enableTSSSO,
    mobileHeaderStyle,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const { width } = useWindowSize();

  const getImgLinkByWidth = () => {
    let imgLink = logo.imgSrc;
    if (width < 991 && logo.imgSrcTablet) {
      imgLink = logo.imgSrcTablet;
    }
    if (width < 767 && logo.imgSrcMobile) {
      imgLink = logo.imgSrcMobile;
    }
    return imgLink;
  };

  const logoEle =
    logo.imgSrc !== '' ? (
      <img className="mainLogo" src={getImgLinkByWidth()} title={logo.title} alt={logo.title} />
    ) : (
      logo.title
    );
  const homeUrl = curLang === 'en' && is_Preview === false ? '/' : `/${curLang}/`;

  const generateMenu = (items = []) => {
    const menuItems = [];
    if (items.length > 0) {
      items.map((item, i) => {
        if (item.menu_level_2) {
          menuItems.push(
            <UncontrolledDropdown nav inNavbar key={i}>
              {generateDropDownMenu(item, i)}
            </UncontrolledDropdown>,
          );
        } else if (isExternalURL(item.url)) {
          menuItems.push(
            <a
              key={i}
              href={item.url}
              className="hideTablet nav-link nav-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
            >
              {parseSanitizedHTML(item.title)}
            </a>,
          );
        } else {
          menuItems.push(
            <NavLink
              key={i}
              to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
              className="hideTablet nav-link nav-item"
              activeClassName="active"
              onClick={() => setIsOpen(false)}
            >
              {parseSanitizedHTML(item.title)}
            </NavLink>,
          );
        }
        return '';
      });
    }
    return menuItems;
  };

  const generateDropDownMenu = (item, i) => {
    const result = [];
    let url = '';
    if (isExternalURL(item.url)) {
      url = (
        <a
          href={item.url}
          className="hideTablet nav-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {parseSanitizedHTML(item.title)}
        </a>
      );
    } else if (item.url) {
      url = (
        <NavLink
          to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
          className="hideTablet nav-link"
          activeClassName="hideTablet active"
        >
          {parseSanitizedHTML(item.title)}
        </NavLink>
      );
    } else {
      url = (
        <span className="hideTablet nav-link active" target="_blank" rel="noopener noreferrer">
          {parseSanitizedHTML(item.title)}
        </span>
      );
    }
    result.push(
      <DropdownToggle caret key={`d${i}`} className="hideTablet nav-dropdown">
        {url}
      </DropdownToggle>,
    );
    result.push(<DropdownMenu key={`m${i}`}>{generateMenuItems(item.menu_level_2)}</DropdownMenu>);
    return result;
  };

  const generateMenuItems = (items = []) => {
    const url = [];
    let newItems = [];
    if (typeof items !== 'undefined' && items instanceof Array) {
      newItems = items;
    } else {
      newItems.push(items);
    }
    if (newItems.length > 0) {
      newItems.map((item, i) => {
        if (isExternalURL(item.url)) {
          url.push(
            <a
              key={i}
              href={item.url}
              className="hideTablet nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
            >
              {parseSanitizedHTML(item.title)}
            </a>,
          );
        } else {
          url.push(
            <NavLink
              key={i}
              to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
              className="hideTablet nav-link"
              activeClassName="hideTablet active"
              onClick={() => setIsOpen(false)}
            >
              {parseSanitizedHTML(item.title)}
            </NavLink>,
          );
        }
        return '';
      });
    }
    return url;
  };

  let menuDropdown;

  if (!isEmpty(menu)) {
    menuDropdown = generateMenu(menu.menu_level_1);
  }

  return (
    <Navbar expand="lg" light className={headerStyle === 2 ? 'headerStyle-2' : ''}>
      <div className="logoContainer" style={{ backgroundColor: logo.bgColor }}>
        <div className="logo">
          <NavLink
            to={(location) => ({ ...location, pathname: c.routePathTo + homeUrl })}
            className="navbar-brand"
          >
            {logoEle}
          </NavLink>
        </div>
        <div className="banner">
          <img src={banner.imgSrc} title={banner.title} alt={banner.title} />
        </div>
      </div>
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} className={isOpen ? '' : 'collapsed'}>
        <span className="icon-bar" />
        <span className="icon-bar" />
        <span className="icon-bar" />
      </NavbarToggler>
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar>
          {menuDropdown}
          <MobilePopMenu
            enableTSSSO={enableTSSSO}
            menu={menu}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
          {/* <MobileMenu menu={menu} setIsOpen={setIsOpen} /> */}
          {mobileHeaderStyle === 2 && (
            <>
              <div className="nav-link nav-item hideNonTablet">
                <MenuButtons type="HeaderTop" />
              </div>
              <div className="nav-link nav-item hideNonTablet">
                <LangSwitcher />
              </div>
            </>
          )}
          <MenuButtons type="MainMenu" className="hideTablet" />
          <HeaderBar type="MainMenu" enableTSSSO={enableTSSSO} />
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default MainMenu;
